// a separate file for constants to avoid import loop
export const ITEMS_GAP = 16;
